(() => {
 document.addEventListener('click', event => {
  const link = event.target.closest('header-drawer a[href*="#divine-"]');
  if(link) {const drawer=link.closest('header-drawer');drawer.closeMenuDrawer?.(event, drawer.querySelector('summary'));}
 });
 function init(root = document) {
  root.querySelectorAll('.dd-pair').forEach(pair => {
   if (pair.dataset.ready) return;
   pair.dataset.ready = 'true';
   const selects = [...pair.querySelectorAll('[data-pair-variant]')];
   const action = pair.querySelector('[data-pair-action]');
   const button = pair.querySelector('[data-add-pair]');
   const status = pair.querySelector('[data-pair-status]');
   if (selects.length !== 2) return;
   action.hidden = false;
   const update = () => {
    const valid = selects.every(s => s.selectedOptions[0] && !s.selectedOptions[0].disabled);
    button.disabled = !valid;
    pair.querySelector('[data-pair-prices]').textContent = valid ? selects.map(s => s.selectedOptions[0].dataset.money).join(' + ') + ' · before any applicable discount' : 'A selected piece is currently unavailable.';
   };
   selects.forEach(s => s.addEventListener('change', update));update();
   button.addEventListener('click', async () => {
    button.disabled = true; status.textContent = 'Adding your pieces…';
    const items = [];
    selects.forEach(s => { const id = Number(s.value); const existing = items.find(i => i.id === id); if(existing) existing.quantity++; else items.push({id, quantity:1}); });
    try {
     const rootUrl = window.Shopify?.routes?.root || '/';
     const response = await fetch(rootUrl + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
     const data = await response.json();
     if(!response.ok) throw new Error(data.description || 'These pieces could not be added. Please try again.');
     status.textContent = 'Added. Opening your bag…';
     window.location.assign(rootUrl + 'cart');
    } catch(error) { status.textContent = error.message || 'Please check your connection and try again.';update(); }
   });
  });

 }
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());else init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
